// Search state management

let searchTimeout;
let isFulltextSearchInProgress = false; // Флаг для идемпотентности performFulltextSearch
let lastFulltextSearchState = null; // Сохраняем последнее состояние поиска (запрос + фильтры)
let hasFulltextSearchBeenRun = false; // Флаг, указывающий, был ли запущен поиск хотя бы раз

export function getSearchTimeout() { return searchTimeout; }
export function setSearchTimeout(timeout) { searchTimeout = timeout; }
export function clearSearchTimeout() { clearTimeout(searchTimeout); }

export function getIsFulltextSearchInProgress() { return isFulltextSearchInProgress; }
export function setIsFulltextSearchInProgress(value) { isFulltextSearchInProgress = value; }

export function getLastFulltextSearchState() { return lastFulltextSearchState; }
export function setLastFulltextSearchState(state) { lastFulltextSearchState = state; }

export function getHasFulltextSearchBeenRun() { return hasFulltextSearchBeenRun; }
export function setHasFulltextSearchBeenRun(value) { hasFulltextSearchBeenRun = value; }

